import { gql } from '@apollo/client';

export const GENERATE_REBALANCE_INSIGHT_NARRATIVE = gql`
  query generateRebalanceInsightNarrative(
    $input: GenerateRebalanceInsightNarrativeInput!
  ) {
    generateRebalanceInsightNarrative(input: $input) {
      response
    }
  }
`;
